'use client';
import Image from 'next/image';
const speakers = [
{
    name: "Konstantin Koshelev",
    designation: "CryptoGrandPa KOL & Ecosystem Lead",
    company: "TONco",
    imageSrc: "/images/speakers/konstantin.webp",
    alt: "konstantin-koshelev",
  },
  {
    name: "Sonny Verueco",
    designation: "Co-Founder",
    company: " PhyGiverse Network",
    imageSrc: "/images/speakers/sonny-verueco.webp",
    alt: "sonny-verueco",
  },
  // speakers 2025 end
 
    {
    name: "Sébastien Borget",
    designation: "Co-founder",
    company: "The Sandbox ",
    imageSrc: "/images/speakers/sebastien-borget.webp",
    alt: "Sébastien-Borget",
  },
  {
    name: "Andy",
    designation: " CCO",
    company: "YOM.net",
    imageSrc: "/images/speakers/andy.webp",
    alt: "Andy",
  },
 
   {
    name: "Mariano Rubinstein",
    designation: "CEO & Co-founder",
    company: "Sura Gaming & Sura Ventures",
    imageSrc: "/images/speakers/mariano-rubinstein.webp",
    alt: "MarianoRubinstein",
  },
    {
    name: "Mihee Park",
    designation: "CFO",
    company: "OL Ltd. (formerly known as Big Time Studios Ltd.) ",
    imageSrc: "/images/speakers/mihee-park.webp",
    alt: "Mihee-Park",
  },
   {
    name: "Ryuzaki",
    designation: "Ambassador, DAO Council Member",
    company: "YOM.net ",
    imageSrc: "/images/speakers/ryuzaki.webp",
    alt: "Ryuzaki",
  }, {
    name: "Flavien Defraire",
    designation: "Director of Global Development",
    company: "Blockchain Gaming Alliance",
    imageSrc: "/images/speakers/flavien-defraire.webp",
    alt: "FlavienDefraire",
  },
   {
    name: "Kevin Soltani",
    designation: "CEO",
    company: "Gima Group",
    imageSrc: "/images/speakers/kevin-soltani.webp",
    alt: "KevinSoltani",
  },
 
];
const SpeakerSection = () => {
  return (
    <section data-component-id="src/app/SpeakersSection.tsx:73:4" data-component-path="src/app/SpeakersSection.tsx" data-component-line="73" data-component-end-line="116" data-component-file="SpeakersSection.tsx" data-component-name="section" data-component-content="%7B%22elementName%22%3A%22section%22%2C%22id%22%3A%22speakers%22%2C%22className%22%3A%22w-full%20bg-White%20p-6%20sm%3Ap-8%20md%3Ap-10%20lg%3Ap-%5B38px%5D%20sm%3Ap-4%22%7D" id='speakers'
      className="w-full bg-White p-6 sm:p-8 md:p-10 lg:p-[38px] sm:p-4"
    >
      <div data-component-id="src/app/SpeakersSection.tsx:76:6" data-component-path="src/app/SpeakersSection.tsx" data-component-line="76" data-component-end-line="115" data-component-file="SpeakersSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-full%20max-w-%5B1300px%5D%20mx-auto%22%7D" className="w-full max-w-[1300px] mx-auto">
        {/* Section Title */}
         <h2 data-component-id="src/app/SpeakersSection.tsx:78:9" data-component-path="src/app/SpeakersSection.tsx" data-component-line="78" data-component-end-line="83" data-component-file="SpeakersSection.tsx" data-component-name="h2" data-component-content="%7B%22elementName%22%3A%22h2%22%2C%22className%22%3A%22text-%5B24px%5D%20sm%3Atext-%5B32px%5D%20lg%3Atext-%5B40px%5D%20font-bold%20leading-tight%20text-center%20uppercase%20text-text-primary%20mb-10%22%2C%22textContent%22%3A%22Past%20Speakers%22%7D"
              className="text-[24px] sm:text-[32px] lg:text-[40px] font-bold leading-tight text-center uppercase text-text-primary mb-10"
              style={{ fontFamily: 'Geologica' }}
            >
              Past Speakers
            </h2>
        {/* Speaker List Box */}
        <div data-component-id="src/app/SpeakersSection.tsx:85:8" data-component-path="src/app/SpeakersSection.tsx" data-component-line="85" data-component-end-line="114" data-component-file="SpeakersSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-full%20mx-auto%22%7D" className="w-full mx-auto">
          {/* Mobile gap-5 and larger screens gap-2 */}
          <div data-component-id="src/app/SpeakersSection.tsx:87:10" data-component-path="src/app/SpeakersSection.tsx" data-component-line="87" data-component-end-line="113" data-component-file="SpeakersSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22grid%20grid-cols-2%20sm%3Agrid-cols-2%20md%3Agrid-cols-3%20lg%3Agrid-cols-4%20gap-6%20sm%3Agap-y-10%20sm%3Agap-2%20place-items-center%22%7D" className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 sm:gap-y-10 sm:gap-2 place-items-center">
            {speakers.map((speaker, index) => (
              <div data-component-id="src/app/SpeakersSection.tsx:89:14" data-component-path="src/app/SpeakersSection.tsx" data-component-line="89" data-component-end-line="111" data-component-file="SpeakersSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20flex-col%20items-center%22%7D" key={index} className="flex flex-col items-center">
                {/* Adjusted Image Container for smaller mobile sizes */}
                <div data-component-id="src/app/SpeakersSection.tsx:91:16" data-component-path="src/app/SpeakersSection.tsx" data-component-line="91" data-component-end-line="101" data-component-file="SpeakersSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-%5B150px%5D%20h-%5B150px%5D%20sm%3Aw-%5B250px%5D%20sm%3Ah-%5B250px%5D%20relative%20mb-4%22%7D" className="w-[150px] h-[150px] sm:w-[250px] sm:h-[250px] relative mb-4">
                  <Image data-component-id="src/app/SpeakersSection.tsx:92:18" data-component-path="src/app/SpeakersSection.tsx" data-component-line="92" data-component-end-line="100" data-component-file="SpeakersSection.tsx" data-component-name="Image" data-component-content="%7B%22elementName%22%3A%22Image%22%2C%22className%22%3A%22rounded-full%22%7D"
                    src={speaker.imageSrc}
                    alt={speaker.alt}
                    width={300}
                    height={300}
                    objectFit="cover"
                    unoptimized
                    className="rounded-full"
                  />
                </div>
                <h3 data-component-id="src/app/SpeakersSection.tsx:102:16" data-component-path="src/app/SpeakersSection.tsx" data-component-line="102" data-component-end-line="104" data-component-file="SpeakersSection.tsx" data-component-name="h3" data-component-content="%7B%22elementName%22%3A%22h3%22%2C%22className%22%3A%22text-%5B%23fff%5D%20text-%5B16px%5D%20sm%3Atext-%5B18px%5D%20font-semibold%20text-center%20mb-1%22%7D" className="text-[#fff] text-[16px] sm:text-[18px] font-semibold text-center mb-1">
                  {speaker.name}
                </h3>
                <p data-component-id="src/app/SpeakersSection.tsx:105:16" data-component-path="src/app/SpeakersSection.tsx" data-component-line="105" data-component-end-line="107" data-component-file="SpeakersSection.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-white%20text-%5B12px%5D%20sm%3Atext-%5B14px%5D%20text-center%20mb-1%22%7D" className="text-white text-[12px] sm:text-[14px] text-center mb-1">
                  {speaker.designation}
                </p>
                <p data-component-id="src/app/SpeakersSection.tsx:108:16" data-component-path="src/app/SpeakersSection.tsx" data-component-line="108" data-component-end-line="110" data-component-file="SpeakersSection.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-white%20text-%5B10px%5D%20sm%3Atext-%5B12px%5D%20text-center%22%7D" className="text-white text-[10px] sm:text-[12px] text-center">
                  {speaker.company}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
export default SpeakerSection;
/////////////////////////////////////////////////////






